Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-installments', function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.x-product-details-installments', $context), control,
            dataProductPrice, totalPrice, productPrice, preferredPaymentMethodId, model,
            $selectedInstallment, $selectedTotal, $initialInstallment;

        if ($control.length < 1) return;

        control = $control.get(0);

        //NOTE: 
        //numerice data attributes that will be used by javascript should be always formatted as javascript numbers e.g. 12345.67
        //to accomplish that use {{serialize YourModelNumericProperty}} in your handlebars. ({PropertyName: "1234"} this is not a number)
        dataProductPrice = $control.data('product-price');
        totalPrice = ((typeof dataProductPrice === 'number') && dataProductPrice) || parseFloat(dataProductPrice);
        productPrice = totalPrice;
        

        preferredPaymentMethodId = $control.data('preferred-payment-method-id');

        control.bind = function () {
            var html = Vendd.Handlebars.parse("pdInstallments_A", model);

            $control.html(html);

            if (!isTouch())
                $('select', $control).sSelect({ ddMaxHeight: '200px' });

            $initialInstallment = $('.js-installment-plan .installment').html();

            $('select', $control).change(function (e) {
                if (!$(this).val()) {
                    $('.js-installment-plan .installment').html($initialInstallment);
                    $('.js-installment-plan .total-cost').empty();
                } else {
                    $selectedInstallment = $(this).find(":selected").data('installment');
                    $selectedTotal = $(this).find(":selected").data('total');

                    $('.js-installment-plan .installment').html(model.Literals.InstallmentsFromText + " " + $selectedInstallment + " " + model.Literals.InstallmentsPeriodText);
                    $('.js-installment-plan .total-cost').html(model.Literals.InstallmentsTotalText + " " + $selectedTotal);
                } 
            });
        };

        Vendd.MessageBus.publishAsync(control, new Vendd.Installments.Messages.GetInstallmentsData(totalPrice, productPrice, preferredPaymentMethodId));

        Vendd.MessageBus.subscribe(Vendd.Installments.Messages.GetInstallmentsDataSuccess, control, function (envelope) {
            model = envelope.message.data.data;
            control.bind();

            Vendd.MessageBus.unsubscribe(Vendd.Installments.Messages.GetInstallmentsDataSuccess, control);
        });

    });

});